export default __webpack_public_path__ + "static/fundamentals-3-9d0432798efe5b5b3447419fe09df4f5.jpg";